import { StorageService } from '../services/storage.service';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { GlobalDataService } from '../providers/global-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ItemRistoranteModel } from '../gest-ristorante/itemRistorante.model';
import { Validators, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ItemDisponibModel } from './itemDisponib.model';
import { interval, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'load-timepicker',
  template: `<ngb-timepicker [(ngModel)]="globalData.orarioRistorante"></ngb-timepicker>`,
  standalone: false
})
export class NgbdTimepickerBasic {
  constructor(public globalData: GlobalDataService) {
    this.globalData.orarioRistorante = { hour: null, minute: null };
  }

}


@Component({
  selector: 'app-gest-ristorante',
  templateUrl: './gest-ristorante.component.html',
  styleUrls: ['./gest-ristorante.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class GestRistoranteComponent implements OnInit, OnDestroy {
  // Dati del componente
  data: string;
  presenteInAnagrafica: string = 'false';
  isIdUtentePresente = false;
  filter = '';
  filterTemp = '';
  elementoSelezionato: number;
  nomePersona = '';
  mostraErroreOrario = false;
  turniAttivi: any[] = [];

  // Models
  itemRistorante: ItemRistoranteModel;
  itemDisponibil: ItemDisponibModel;

  // Forms
  ristoranteForm: UntypedFormGroup;
  itemDisponibilForm: UntypedFormGroup;

  // Observables e subscriptions
  private readonly debouncerOrdini = new Subject<string>();
  private readonly destroy$ = new Subject<void>();
  private intervalSubscription: Subscription;
  private tokenValue: string;

  constructor(
    public globalData: GlobalDataService,
    private http: HttpClient,
    private storage: StorageService
  ) {
    this.itemRistorante = new ItemRistoranteModel();
    this.itemDisponibil = new ItemDisponibModel();
    this.initializeData();
    this.setupDebouncer();
    this.tokenValue = this.storage.get('token');
    this.globalData.getListaUtenti();
  }

  private initializeData(): void {
    if (!this.data) {
      const today = new Date();
      const formattedDate = this.formatDate(today);
      this.data = formattedDate.iso;
      this.globalData.dataSceltaFormatoIta = formattedDate.italian;
      this.globalData.dataScelta = formattedDate.iso;
    }
  }

  private formatDate(date: Date): { iso: string; italian: string } {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return {
      iso: `${year}-${month}-${day}`,
      italian: `${day}-${month}-${year}`
    };
  }

  private setupDebouncer(): void {
    this.debouncerOrdini.pipe(
      debounceTime(900),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(value => {
      this.filter = this.filterTemp;
      // Reset della selezione quando cambia il filtro
      this.elementoSelezionato = null;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
  }

  resettaFiltro(): void {
    this.filter = '';
    this.filterTemp = '';
    this.elementoSelezionato = null;
    this.globalData.itemsFiltrati = null;
  }

  getFilteredUsers(): any[] {
    if (!this.globalData.listaUtenti || !this.filter) {
      return [];
    }

    const searchTerm = this.filter.toLowerCase();
    return this.globalData.listaUtenti.filter((utente: any) => {
      return utente.nome?.toLowerCase().includes(searchTerm) ||
        utente.cognome?.toLowerCase().includes(searchTerm) ||
        utente.telefono?.includes(searchTerm) ||
        utente.email?.toLowerCase().includes(searchTerm);
    });
  }

  valorizzaModale(): void {
    const selectedIndex = parseInt(this.elementoSelezionato as any);

    if (isNaN(selectedIndex) || selectedIndex < 0) {
      return;
    }

    const filteredList = this.getFilteredUsers();
    const userData = filteredList?.[selectedIndex];

    if (userData) {
      // Popola i campi del form
      this.itemRistorante.nome = userData.nome;
      this.itemRistorante.cognome = userData.cognome;
      this.itemRistorante.telefono = userData.telefono;
      this.itemRistorante.idUtente = userData.idUtente;

      // Aggiorna anche i controlli del form
      this.ristoranteForm.patchValue({
        nome: userData.nome,
        cognome: userData.cognome,
        telefono: userData.telefono
      });
    }
  }



  toggleAlertNewBookings(): void {
    this.globalData.showAlertNewBookingsRist = !this.globalData.showAlertNewBookingsRist;
  }

  ngOnInit() {
    this.aggiornaDisponibilita(this.globalData.dataScelta);
    this.globalData.getPrenotazioniRistorante(this.globalData.dataScelta);
    this.caricaTurniAttivi(this.globalData.dataScelta);

    // Auto-refresh ogni 2 minuti per ridurre anomalie di prenotazione
    this.intervalSubscription = interval(120000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (!this.globalData.modificaInCorso) {
          this.refreshData();
        }
      });




    this.ristoranteForm = new UntypedFormGroup({
      nome: new UntypedFormControl('', [Validators.required, Validators.pattern('[àéèùòìa-zA-Z\' ]*'), Validators.minLength(3), Validators.maxLength(25)]),
      cognome: new UntypedFormControl('', [Validators.required, Validators.pattern('[àéèùòìa-zA-Z\' ]*'), Validators.minLength(2), Validators.maxLength(20)]),
      telefono: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9 ]*'), Validators.minLength(10)]),
      idTurno: new UntypedFormControl('', [Validators.required]),
      nomePersona: new UntypedFormControl(''),
      numeroCoperti: new UntypedFormControl('', [Validators.required])

    });

    this.itemDisponibilForm = new UntypedFormGroup({
      fasciaOraria: new UntypedFormControl('', [Validators.required]),
      numeroCoperti: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9 ]*')]),
      idTipoPrenotazioneRistoranteConsentita: new UntypedFormControl('', [Validators.required])

    });

    // Form dei datepicker dei modali ristorante (prima creati nei vecchi wrapper datepicker)
    this.globalData.ristoranteAddForm = new UntypedFormGroup({
      data: new UntypedFormControl('', [Validators.required])
    });
    this.globalData.ristoranteEditForm = new UntypedFormGroup({
      data: new UntypedFormControl('', [Validators.required])
    });
    this.globalData.ristoranteDispForm = new UntypedFormGroup({
      data: new UntypedFormControl('', [Validators.required])
    });
  }

  resettaOrario(): void {
    this.itemRistorante.orario = '';
    this.validateOrarioSelection();
  }

  resettaErrore(): void {
    this.validateOrarioSelection();
  }

  private validateOrarioSelection(): void {
    const { fasciaOraria, orario } = this.itemRistorante;
    this.mostraErroreOrario = Boolean(fasciaOraria && !orario);
  }


  preparaDeletePrenotazioneRistorante(item: any): void {
    this.itemRistorante.idPrenotazioneRistorante = item.idPrenotazioneRistorante;
    this.itemRistorante.nome = `${item.utente.nome} ${item.utente.cognome}`;
  }

  deletePrenotazioneRistorante(id) {
    this.globalData.spinner.show();


    this.tokenValue = this.storage.get('token');

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.tokenValue
    });

    let postData = {
      "idPrenotazioneRistorante": id
    }

    this.http.post(this.globalData.serviziRest.deletePrenotazioneRist, postData, { headers })
      .subscribe(data => {

        setTimeout(function () {
          this.globalData.getPrenotazioniRistorante(this.globalData.dataScelta);
          this.globalData.spinner.hide();
          this.resetCampiModale();
        }.bind(this), 3000);

      }, error => {
        this.globalData.spinner.hide();
        if (error.status == 0) {
          // Errore di connessione
        } else if (error.status == 400 || error.status == 401 || error.status == 403) {
          // Errore di autenticazione/autorizzazione
        } else {
          // Altri errori
        }
      });

  }
  modInCorso(): void {
    this.globalData.modificaInCorso = true;
    this.caricaTurniAttivi(this.globalData.dataAddRistorante || this.globalData.dataScelta);
  }

  apriModaleDisponibilita(): void {
    this.caricaTurniAttivi(this.globalData.dataScelta);
  }

  caricaTurniAttivi(data: string): void {
    if (!data) return;

    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.tokenValue
    });

    const url = `${this.globalData.serviziRest.getTurniRistoranteAttivi}?idRistorante=1&data=${data}`;

    this.http.get<any[]>(url, { headers: headers }).subscribe(
      turni => {
        this.turniAttivi = turni || [];
        console.log('Turni caricati:', this.turniAttivi);
      },
      error => {
        console.error('Errore caricamento turni attivi:', error);
        this.turniAttivi = [];
      }
    );
  }

  resetCampiModale(): void {
    // Reset form states
    this.presenteInAnagrafica = 'false';
    this.mostraErroreOrario = false;
    this.nomePersona = '';
    this.elementoSelezionato = null;

    // Reset filters
    this.resettaFiltro();

    // Reset forms
    this.ristoranteForm?.reset();
    this.itemDisponibilForm?.reset();

    // Reset global data
    this.globalData.dataAddRistorante = '';
    this.globalData.dataEditRistorante = '';
    this.globalData.dataDispRistorante = '';
    this.globalData.modificaInCorso = false;

    // Reset global forms
    this.globalData.ristoranteAddForm?.reset();
    this.globalData.ristoranteEditForm?.reset();
    this.globalData.ristoranteDispForm?.reset();

    // Reset model
    this.itemRistorante = new ItemRistoranteModel();
    this.itemDisponibil = new ItemDisponibModel();
  }

  aggiungiPersona(nome: string): void {
    if (nome?.trim()) {
      this.itemRistorante.listaCommensali.push({ nome: nome.trim() });
      this.nomePersona = '';
    }
  }

  rimuoviPersonaDaLista(indice: number): void {
    if (indice >= 0 && indice < this.itemRistorante.listaCommensali.length) {
      this.itemRistorante.listaCommensali.splice(indice, 1);
    }
  }

  addPrenotazioneRistorante(itemRistorante) {
    this.globalData.modificaInCorso = true;
    this.globalData.spinner.show();

    this.tokenValue = this.storage.get('token');

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.tokenValue
    });

    let dataScelta = this.globalData.dataAddRistorante.year + "-" + this.globalData.dataAddRistorante.month + "-" + this.globalData.dataAddRistorante.day; // prepararo la data con cui chiamare il servizio, nel formato aaaa-mm-gg

    this.itemRistorante.data = this.fixZeriData(this.globalData.dataAddRistorante);


    // Trova il turno selezionato per ottenere il labelTurno
    const turnoSelezionato = this.turniAttivi.find(t => t.idTurno == itemRistorante.idTurno);
    const orario = turnoSelezionato ? turnoSelezionato.labelTurno : '';

    let postData = {
      "utente": {
        "idUtente": itemRistorante.idUtente,
        "nome": itemRistorante.nome,
        "cognome": itemRistorante.cognome,
        "telefono": itemRistorante.telefono,
      },
      "idTurno": itemRistorante.idTurno,
      "orario": orario,
      "nota": itemRistorante.note,
      "idFonte": 3, // idFonte = 3 significa prenotazione inviata da Gestionale
      "dataPrenotata": this.itemRistorante.data,
      "numeroCoperti": itemRistorante.coperti,
      "listaCommensali": itemRistorante.listaCommensali
    }

    this.http.post(this.globalData.serviziRest.insertPrenotazioneRist, postData, { headers })
      .subscribe(data => {
        setTimeout(function () {
          this.globalData.spinner.hide();
          this.resetCampiModale();
          this.globalData.getPrenotazioniRistorante(this.globalData.dataScelta);
        }.bind(this), 3000);
      }, error => {
        setTimeout(function () {
          this.globalData.spinner.hide();
        }.bind(this), 3000);
      });

  }

  preparaModificaRistorante(item) {

    this.globalData.modificaInCorso = true;

    this.itemRistorante.listaCommensali = item.listaCommensali;
    this.itemRistorante.nome = item.utente.nome;
    this.itemRistorante.cognome = item.utente.cognome;
    this.itemRistorante.telefono = item.utente.telefono;
    this.itemRistorante.idTurno = String(item.idTurno);
    this.itemRistorante.coperti = item.numeroCoperti;
    this.itemRistorante.orario = item.orario;
    this.itemRistorante.note = item.nota;
    this.itemRistorante.idUtente = item.idUtente;
    this.itemRistorante.idPrenotazioneRistorante = item.idPrenotazioneRistorante;

    console.log('idTurno da valorizzare:', this.itemRistorante.idTurno);

    // Carica i turni attivi
    let data = this.globalData.dataScelta;

    // Se dataEditRistorante è un oggetto, convertilo in stringa
    if (this.globalData.dataEditRistorante && typeof this.globalData.dataEditRistorante === 'object') {
      data = this.fixZeriData(this.globalData.dataEditRistorante);
    }

    if (data) {
      const headers = new HttpHeaders({
        'Authorization': 'Bearer ' + this.tokenValue
      });

      const url = `${this.globalData.serviziRest.getTurniRistoranteAttivi}?idRistorante=1&data=${data}`;

      this.http.get<any[]>(url, { headers: headers }).subscribe(
        turni => {
          this.turniAttivi = turni || [];
          console.log('Turni caricati:', this.turniAttivi);

          // Forza l'aggiornamento del form dopo il caricamento
          setTimeout(() => {
            this.ristoranteForm.patchValue({
              idTurno: String(item.idTurno)
            });
          }, 100);
        },
        error => {
          console.error('Errore caricamento turni attivi:', error);
          this.turniAttivi = [];
        }
      );
    }

    if (this.globalData.dataScelta != null && this.globalData.dataScelta != '') {
      var d = this.globalData.dataScelta.split("-");

      d[0] = d[0] * 1;


      if (d[1].substring(0, 1) == '0') {
        d[1].substring(0, 1).replace("0", "");
        d[1].trim();
      }
      d[1] = d[1] * 1;


      if (d[2].substring(0, 1) == '0') {
        d[2].substring(0, 1).replace("0", "");
        d[2].trim();
      }
      d[2] = d[2] * 1;

      // Usa setTimeout per evitare ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        this.globalData.dataEditRistorante = {
          day: d[2],
          month: d[1],
          year: d[0],
        };
      }, 0);
    }

  }
  modificaPrenotazioneRistorante(itemRistorante) {

    if (this.globalData.dataEditRistorante.year != '' && this.globalData.dataEditRistorante.year != undefined && this.globalData.dataEditRistorante.year != '--') {
      this.itemRistorante.data = this.globalData.dataEditRistorante.year + "-" + this.globalData.dataEditRistorante.month + "-" + this.globalData.dataEditRistorante.day;

    }


    let dataDaModificare = null;
    dataDaModificare = this.itemRistorante.data.split("-");
    let mese = '' + dataDaModificare[1];
    let giorno = '' + dataDaModificare[2];
    let anno = '' + dataDaModificare[0];

    if (mese.length < 2) mese = '0' + mese;
    if (giorno.length < 2) giorno = '0' + giorno;
    let dataModificata = anno + "-" + mese + "-" + giorno;
    this.globalData.spinner.show();

    this.tokenValue = this.storage.get('token');

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.tokenValue
    });

    // Trova il turno selezionato per ottenere il labelTurno
    const turnoSelezionato = this.turniAttivi.find(t => t.idTurno == itemRistorante.idTurno);
    const orario = turnoSelezionato ? turnoSelezionato.labelTurno : '';

    let postData = {
      "utente": {
        "idUtente": itemRistorante.idUtente,
        "nome": itemRistorante.nome,
        "cognome": itemRistorante.cognome,
        "telefono": itemRistorante.telefono,
      },
      "idPrenotazioneRistorante": itemRistorante.idPrenotazioneRistorante,
      "idTurno": itemRistorante.idTurno,
      "orario": orario,
      "idFonte": 3, // idFonte = 3 significa prenotazione inviata da Gestionale
      "dataPrenotata": dataModificata,
      "nota": itemRistorante.note,
      "numeroCoperti": itemRistorante.coperti,
      "listaCommensali": itemRistorante.listaCommensali
    }

    this.http.post(this.globalData.serviziRest.updatePrenotazioneRist, postData, { headers })
      .subscribe(data => {
        setTimeout(function () {
          this.globalData.spinner.hide();
          this.resetCampiModale();
          this.globalData.getPrenotazioniRistorante(this.globalData.dataScelta);
        }.bind(this), 3000);
      }, error => {
        setTimeout(function () {
          this.resetCampiModale();
          this.globalData.spinner.hide();
        }.bind(this), 3000);
      });

  }

  getTipoPrenotazioneLabel(id: number): string {
    switch (id) {
      case 1: return 'Ristorante e Pizzeria';
      case 2: return 'Solo Ristorante';
      case 3: return 'Solo Pizzeria';
      default: return '';
    }
  }

  getLabelTurno(idTurno: number): string {
    const turno = this.turniAttivi.find(t => t.idTurno === idTurno);
    return turno?.labelTurno || '';
  }

  private refreshData(): void {
    this.globalData.spinner.show();

    if (!this.globalData.dataScelta) {
      const today = new Date();
      this.globalData.dataScelta = this.formatDate(today).iso;
    }

    this.globalData.getPrenotazioniRistorante(this.globalData.dataScelta);
  }

  private aggiornaDisponibilita(data: string): void {
    Promise.all([
      this.globalData.getDisponibilitaPranzo(data),
      this.globalData.getDisponibilitaCena(data)
    ]);
  }


  private fixZeriData(data: any): string {
    const year = data.year;
    const month = String(data.month).padStart(2, '0');
    const day = String(data.day).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  cambiaDispRistorante(nuovaDisp) {
    this.globalData.spinner.show();
    this.itemDisponibil.data = this.fixZeriData(this.globalData.dataDispRistorante);


    this.itemDisponibil.fasciaOraria = nuovaDisp.fasciaOraria;
    this.itemDisponibil.numeroCoperti = nuovaDisp.numeroCoperti;
    this.itemDisponibil.idTipoPrenotazioneRistoranteConsentita = nuovaDisp.idTipoPrenotazioneRistoranteConsentita;

    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.tokenValue,
      'Content-Type': 'application/json'
    });
    let postData = {
      "data": this.itemDisponibil.data,
      "idTurno": this.itemDisponibil.fasciaOraria,
      "postiDisponibili": this.itemDisponibil.numeroCoperti,
      "idTipoPrenotazioneRistoranteConsentita": this.itemDisponibil.idTipoPrenotazioneRistoranteConsentita
    }

    this.http.post(this.globalData.serviziRest.updateDisponibilitaRistorante, postData, { headers })
      .subscribe(data => {

        this.aggiornaDisponibilita(this.itemDisponibil.data);
        setTimeout(function () {
          this.globalData.spinner.hide();
        }.bind(this), 1000);
      }, error => {
        setTimeout(function () {
          this.globalData.spinner.hide();
        }.bind(this), 1000);
      });
  }

  chiudiTuttiTurni(data: string): void {
    if (!data) {
      console.error('Data non disponibile');
      return;
    }

    this.globalData.spinner.show();
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.tokenValue,
      'Content-Type': 'application/json'
    });

    const postData = {
      "data": data,
      "postiDisponibili": 0
    };

    this.http.post(this.globalData.serviziRest.updateDisponibilitaRistoranteGiorno, postData, { headers })
      .subscribe(
        () => {
          this.aggiornaDisponibilita(data);
          setTimeout(() => {
            this.globalData.spinner.hide();
          }, 1000);
        },
        error => {
          console.error('Errore durante la chiusura dei turni:', error);
          setTimeout(() => {
            this.globalData.spinner.hide();
          }, 1000);
        }
      );
  }
}
